import axios from 'axios';

export default axios.create({
  baseURL: 'https://api-staging-vitals.carenow.healthcare',
});
